// SPDX-License-Identifier: AGPL-3.0-or-later

import {z} from 'zod';

z.config({jitless: true});
